import React from 'react'
import ReactSwitch from 'react-switch'
import { SwitchProps } from './Switch.types'

//TODO(v1): Implement custom version - current component takes up ~50kB unpacked
export const Switch: React.FC<SwitchProps> = ({
  checked,
  disabled = false,
  onChange,
  ...props
}) => {
  return (
    <ReactSwitch
      disabled={disabled}
      handleDiameter={16}
      checkedIcon={false}
      uncheckedIcon={false}
      onChange={onChange}
      checked={checked}
      {...props}
    />
  )
}
